let language = {
    // anchor
    // WOOCOMMERCE
    "WOOCOMMERCE-PLUGIN-ANCHOR-UPDATE": "步骤1. 将您的 WooCommerce 升级到最新版本",
    "WOOCOMMERCE-PLUGIN-ANCHOR-INSTALL": "步骤2. 安装 QPMN 插件",
    "WOOCOMMERCE-PLUGIN-ANCHOR-INSTALL-QPSON": "步骤2. 安装 QPSON 插件",
    "WOOCOMMERCE-PLUGIN-ANCHOR-SEARCH": '步骤3. 在 WooCommerce 中搜索 "QPMN"',
    "WOOCOMMERCE-PLUGIN-ANCHOR-SEARCH-QPSON": '步骤3. 在 WooCommerce 中搜索 "QPSON"',
    "WOOCOMMERCE-PLUGIN-ANCHOR-ENABLE": '步骤4. 安装并激活 QPMN 插件',
    "WOOCOMMERCE-PLUGIN-ANCHOR-ENABLE-QPSON": '步骤4. 安装并激活 QPSON 插件',
    "WOOCOMMERCE-PLUGIN-ANCHOR-SETTING": '步骤5. 在 WooCommerce 设置中启用 REST API',
    "WOOCOMMERCE-PLUGIN-ANCHOR-STORE-KEY": '步骤6. 设置店铺密钥',
    "WOOCOMMERCE-PLUGIN-ANCHOR-STORE-CONTACT": '联系我们',

    // SNAPSHOP
    "WOOCOMMERCE-PLUGIN-ANCHOR-SNAPSHOP-SET": '1. 使用 SnapShop 设置您的店铺',
    "WOOCOMMERCE-PLUGIN-ANCHOR-SNAPSHOP-CONNECT": '2. 将您的 WooCommerce 店铺连接到 QPMN',
    "WOOCOMMERCE-PLUGIN-ANCHOR-SNAPSHOP-CONNECT-QPSON": '2. 将您的 WooCommerce 店铺连接到 QPSON',
    "WOOCOMMERCE-PLUGIN-ANCHOR-SNAPSHOP-ADDING": '3. 开始添加产品',

    "WOOCOMMERCE-PLUGIN-CONTAINER-TITLE": "将您的 WooCommerce 店铺连接到 {{appName}}",
    "WOOCOMMERCE-PLUGIN-CONTAINER-TAB-HEAD": "我想连接一个现有的店铺",
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP1-TITLE": "1. 将 WooCommerce 升级到最新版本",
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP1-DESCRIPTION": `{{appName}} 的某些功能与旧版本的 WooCommerce 不兼容。 
    因此，如果您想将店铺连接到 {{appName}}，需要将 WooCommerce 升级到 6.5.1 以上版本`,
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP2-TITLE": "2. 安装 {{appName}} 插件",
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP2-DESCRIPTION-1": "前往您的",
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP2-DESCRIPTION-2": "WordPress",
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP2-DESCRIPTION-3": '，并打开 "插件" 标签。',
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP3-TITLE": "3. 在 WooCommerce 中搜索 {{appName}}",
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP3-DESCRIPTION": "在添加插件页面的搜索栏中搜索 {{appName}}。",
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP4-TITLE": "4. 安装并激活 {{appName}} 插件",
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP4-DESCRIPTION": '找到 {{appName}} 插件后，点击 "立即安装"，安装完成后点击 "启用"。',
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP5-TITLE": "5. 在 WooCommerce 设置中启用 REST API",
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP5-DESCRIPTION-1": `1. 在您的店铺管理面板中，打开 "WooCommerce" → "设置" → "高级" → "旧版 API"。
    请确保已勾选 "启用旧版 REST API"`,
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP5-DESCRIPTION-2": `2. 切换到 "REST API"。`,
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP5-DESCRIPTION-3": `3. 设置密钥，您可以设置密钥的描述信息、用户名和用户权限。`,
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP5-DESCRIPTION-4": `4. 点击生成 API 密钥`,
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP5-DESCRIPTION-API": `此密钥用于验证 {{appName}} 网站调用 WooCommerce API。`,
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP5-DESCRIPTION-5": `5. 保持在当前页面，使用 Consumer Key 和 Consumer Secret 进入 {{appName}} 完成店铺创建。`,
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP5-DESCRIPTION-6": `6. 在创建店铺的最后一步，填写这两个值以完成连接`,
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP5-DESCRIPTION-VIEW": `您可以在这里查看 API`,
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP6-TITLE": `6. 设置店铺密钥`,
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP6-DESCRIPTION-CREATING": `创建店铺后将获得密钥，这是 WooCommerce 调用 {{appName}} 网站 API 的凭证。`,
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP6-DESCRIPTION-1": `1. 打开 {{appName}} 个人中心中的 "店铺"。`,
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP6-DESCRIPTION-2": `2. 重新认证以获取店铺令牌。`,
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP6-DESCRIPTION-3": `3. 填写店铺密钥`,
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP7-TITLE": `联系我们`,
    "WOOCOMMERCE-PLUGIN-CONTAINER-STEP7-DESCRIPTION": `如有任何疑问，请联系我们`,
};

export { language }
